import React, { useState } from "react";
import axios from "axios";

import {
  Button,
  FormGroup,
  Label,
  Input,
  ControlledSelect,
} from "./form";

export default function GetInfoForm() {
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [email, setEmail] = useState("");
  const [country, setCountry] = useState("");
  const [studentType, setStudentType] = useState("");
  const [program, setProgram] = useState("");
  const [startTerm, setStartTerm] = useState("");

  const submitForm = (e) => {
    e.preventDefault();
    setSubmitting(true);

    axios({
      method: "POST",
      url: "https://salesforce.mediacross.com/maryville/update-object",
      data: {
        object: "Contact",
        fields: [
          {
            name: "FirstName",
            value: firstName,
          },
          {
            name: "LastName",
            value: lastName,
          },
          {
            name: "Email",
            value: email,
          },
          {
            name: "Birthdate",
            value: dateOfBirth,
          },
          {
            name: "hed__Citizenship__c",
            value: country
          },
          {
            name: "TargetX_SRMb__Citizenship__c",
            value: "Other"
          },
          {
            name: "TargetX_SRMb__Status__c",
            value: "Inquiry"
          }
        ],
        create_only: [
          {
            name: "LeadSource",
            value: "Passport Response"
          }
        ],
        where: [
          {
            field: "Email",
            value: email,
          },
          {
            field: "FirstName",
            value: firstName,
          },
          {
            field: "LastName",
            value: lastName,
          }
        ]
      }
    }).then((res) => {
      const contactId = res.data.id;

      axios({
        method: "POST",
        url: "https://salesforce.mediacross.com/maryville/update-object",
        data: {
          object: "TargetX_SRMb__Inquiry__c",
          fields: [
            {
              name: "TargetX_SRMb__Contact__c",
              value: contactId,
            },
            {
              name: "TargetX_SRMb__Student_Type__c",
              value: studentType,
            },
            {
              name: "TargetX_SRMb__Program__c",
              value: program,
            },
            {
              name: "Start_Term__c",
              value: startTerm.split(' ')[0],
            },
            {
              name: "Start_Term_Year__c",
              value: startTerm.split(' ')[1],
            },
            {
              name: "RecordTypeId",
              value: "0121U000000lJWoQAM",
            },
            {
              name: "Delivery_Method__c",
              value: "On Campus - Trad",
            },
            {
              name: "TargetX_SRMb__Level__c",
              value: "Undergraduate",
            },
            {
              name: "TargetX_SRMb__Degree__c",
              value: "Bachelors",
            },
            {
              name: "TargetX_SRMb__Source__c",
              value: "Passport Response",
            },
          ],
          where: [
            {
              field: "TargetX_SRMb__Contact__c",
              value: contactId,
            },
            {
              field: "TargetX_SRMb__Source__c",
              value: "Passport Response",
            },
          ]
        }
      }).then((res) => {
        setSubmitted(true);
      });
    });
  }

  return (
    <div>
    {!submitted &&
    <form className="flex flex-wrap">
      <FormGroup>
        <Label htmlFor="firstName">First/Given Name</Label>
        <Input type="text" id="firstName" onChange={(e) => { setFirstName(e.target.value)}} />
      </FormGroup>
      <FormGroup>
        <Label htmlFor="lastName">Last/Family Name</Label>
        <Input type="text" id="lastName" onChange={(e) => { setLastName(e.target.value)}} />
      </FormGroup>
      <FormGroup>
        <Label htmlFor="dob">Date of Birth</Label>
        <Input type="date" id="dob" onChange={(e) => { setDateOfBirth(e.target.value)}} />
      </FormGroup>
      <FormGroup>
        <Label htmlFor="email">Email</Label>
        <Input type="text" id="email" onChange={(e) => { setEmail(e.target.value)}} />
      </FormGroup>
      <FormGroup>
        <Label htmlFor="country">Country of Citizenship</Label>
        <ControlledSelect
          id="country"
          value={country}
          onChange={(e) => {
            setCountry(e.target.value);
          }}
          options={countryList.map((country) => {
            return { label: country, value: country };
          })}
        />
      </FormGroup>
      <FormGroup>
        <Label htmlFor="studentType">Student Type</Label>
        <ControlledSelect
          id="studentType"
          value={studentType}
          onChange={(e) => {
            setStudentType(e.target.value);
          }}
          options={[
            {
              label: "...",
              value: "",
            },
            {
              label: "Freshman",
              value: "First-Time Freshman",
            },
            {
              label: "Transfer",
              value: "Transfer",
            },
          ]}
        />
      </FormGroup>
      <FormGroup>
        <Label htmlFor="program">Anticipated Program</Label>
        <ControlledSelect
          id="program"
          value={program}
          onChange={(e) => {
            setProgram(e.target.value);
          }}
          options={
            !studentType
              ? [{ label: "Please Select a Student Type", value: "" }]
              : (studentType === "First-Time Freshman" ? anticipatedProgramFreshmanOptions : anticipatedProgramTransferOptions)
          }
        />
      </FormGroup>
      <FormGroup>
        <Label htmlFor="startTerm">Start Term</Label>
        <ControlledSelect
          id="startTerm"
          value={startTerm}
          onChange={(e) => {
            setStartTerm(e.target.value);
          }}
          options={
            !program
              ? [{ label: "Select a Program", value: "" }]
              : [
                  { label: "...", value: "" },
                  { label: "Spring 2024", value: "Spring 2024" },
                  { label: "Fall 2024", value: "Fall 2024" },
                  { label: "Spring 2025", value: "Spring 2025" },
                  { label: "Fall 2025", value: "Fall 2025" },
                ]
          }
        />
      </FormGroup>
      <div className="px-6 w-full mt-4 text-center">
        <Button extraClasses="w-full md:w-auto bg-red border-red text-white" onClick={submitForm} disabled={submitting}>
          {submitting ? "Sending..." : "Get Info"}
        </Button>
      </div>
    </form>
    }
    {submitted &&
    <h2 className="text-center">Thank you for providing us with your information. We're so excited to learn more about you and share all the reasons why you belong at Maryville.</h2>
    }
    </div>
  );
}

const countryList = [
  "",
  "Afghanistan",
  "Åland Islands",
  "Albania",
  "Algeria",
  "American Samoa",
  "Andorra",
  "Angola",
  "Anguilla",
  "Antarctica",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Aruba",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas (the)",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bermuda",
  "Bhutan",
  "Bolivia (Plurinational State of)",
  "Bonaire, Sint Eustatius and Saba",
  "Bosnia and Herzegovina",
  "Botswana",
  "Bouvet Island",
  "Brazil",
  "British Indian Ocean Territory (the)",
  "Brunei Darussalam",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cabo Verde",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Cayman Islands (the)",
  "Central African Republic (the)",
  "Chad",
  "Chile",
  "China",
  "Christmas Island",
  "Cocos (Keeling) Islands (the)",
  "Colombia",
  "Comoros (the)",
  "Congo (the Democratic Republic of the)",
  "Congo (the)",
  "Cook Islands (the)",
  "Costa Rica",
  "Croatia",
  "Cuba",
  "Curaçao",
  "Cyprus",
  "Czechia",
  "Côte d'Ivoire",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic (the)",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Eswatini",
  "Ethiopia",
  "Falkland Islands (the) [Malvinas]",
  "Faroe Islands (the)",
  "Fiji",
  "Finland",
  "France",
  "French Guiana",
  "French Polynesia",
  "French Southern Territories (the)",
  "Gabon",
  "Gambia (the)",
  "Georgia",
  "Germany",
  "Ghana",
  "Gibraltar",
  "Greece",
  "Greenland",
  "Grenada",
  "Guadeloupe",
  "Guam",
  "Guatemala",
  "Guernsey",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Heard Island and McDonald Islands",
  "Holy See (the)",
  "Honduras",
  "Hong Kong",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran (Islamic Republic of)",
  "Iraq",
  "Ireland",
  "Isle of Man",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jersey",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Korea (the Democratic People's Republic of)",
  "Korea (the Republic of)",
  "Kuwait",
  "Kyrgyzstan",
  "Lao People's Democratic Republic (the)",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Macao",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands (the)",
  "Martinique",
  "Mauritania",
  "Mauritius",
  "Mayotte",
  "Mexico",
  "Micronesia (Federated States of)",
  "Moldova (the Republic of)",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Montserrat",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands (the)",
  "New Caledonia",
  "New Zealand",
  "Nicaragua",
  "Niger (the)",
  "Nigeria",
  "Niue",
  "Norfolk Island",
  "Northern Mariana Islands (the)",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Palestine, State of",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines (the)",
  "Pitcairn",
  "Poland",
  "Portugal",
  "Puerto Rico",
  "Qatar",
  "Republic of North Macedonia",
  "Romania",
  "Russian Federation (the)",
  "Rwanda",
  "Réunion",
  "Saint Barthélemy",
  "Saint Helena, Ascension and Tristan da Cunha",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Martin (French part)",
  "Saint Pierre and Miquelon",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Sint Maarten (Dutch part)",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Georgia and the South Sandwich Islands",
  "South Sudan",
  "Spain",
  "Sri Lanka",
  "Sudan (the)",
  "Suriname",
  "Svalbard and Jan Mayen",
  "Sweden",
  "Switzerland",
  "Syrian Arab Republic",
  "Taiwan (Province of China)",
  "Tajikistan",
  "Tanzania, United Republic of",
  "Thailand",
  "Timor-Leste",
  "Togo",
  "Tokelau",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Turks and Caicos Islands (the)",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates (the)",
  "United Kingdom of Great Britain and Northern Ireland (the)",
  "United States Minor Outlying Islands (the)",
  "United States of America (the)",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Venezuela (Bolivarian Republic of)",
  "Viet Nam",
  "Virgin Islands (British)",
  "Virgin Islands (U.S.)",
  "Wallis and Futuna",
  "Western Sahara",
  "Yemen",
  "Zambia",
  "Zimbabwe",
];

const anticipatedProgramFreshmanOptions = [
  {
    label: "...",
    value: "",
  },
  {
    label: 'Accounting',
    value: 'Accounting'
  },
  {
    label: 'Accounting Information Systems',
    value: 'Accounting Information Systems'
  },
  {
    label: 'Actuarial Science',
    value: 'Actuarial Science'
  },
  {
    label: 'Art (Studio)',
    value: 'Art (Studio)'
  },
  {
    label: 'Biochemistry',
    value: 'Biochemistry'
  },
  {
    label: 'Biology',
    value: 'Biology'
  },
  {
    label: 'Biomedical Science',
    value: 'Biomedical Science'
  },
  {
    label: 'Biotechnology',
    value: 'Biotechnology'
  },
  {
    label: 'Business Administration',
    value: 'Business Administration'
  },
  {
    label: 'Chemistry',
    value: 'Chemistry'
  },
  {
    label: 'Clinical Laboratory Science',
    value: 'Clinical Laboratory Science'
  },
  {
    label: 'Communication',
    value: 'Communication'
  },
  {
    label: 'Communication Sciences and Disorders',
    value: 'Communication Sciences and Disorders'
  },
  {
    label: 'Criminal Justice/Criminology',
    value: 'Criminal Justice/Criminology'
  },
  {
    label: 'Cyber Security',
    value: 'Cyber Security'
  },
  {
    label: 'Data Science',
    value: 'Data Science'
  },
  {
    label: 'Early Childhood and Elementary Education',
    value: 'Early Childhood and Elementary Education'
  },
  {
    label: 'Elementary Education',
    value: 'Elementary Education'
  },
  {
    label: 'Engineering (Dual Degree)',
    value: 'Engineering (Dual Degree)'
  },
  {
    label: 'English',
    value: 'English'
  },
  {
    label: 'Exercise Science',
    value: 'Exercise Science'
  },
  {
    label: 'Financial Services',
    value: 'Financial Services'
  },
  {
    label: 'Forensic Psychology/Criminal Justice',
    value: 'Forensic Psychology/Criminal Justice'
  },
  {
    label: 'Forensic Science',
    value: 'Forensic Science'
  },
  {
    label: 'Game Design',
    value: 'Game Design'
  },
  {
    label: 'Graphic Design',
    value: 'Graphic Design'
  },
  {
    label: 'History',
    value: 'History'
  },
  {
    label: 'Interactive Design',
    value: 'Interactive Design'
  },
  {
    label: 'Interior Design',
    value: 'Interior Design'
  },
  {
    label: 'International Studies',
    value: 'International Studies'
  },
  {
    label: 'Liberal Studies',
    value: 'Liberal Studies'
  },
  {
    label: 'Management and Leadership',
    value: 'Management and Leadership'
  },
  {
    label: 'Management Information Systems',
    value: 'Management Information Systems'
  },
  {
    label: 'Marketing',
    value: 'Marketing'
  },
  {
    label: 'Mathematics',
    value: 'Mathematics'
  },
  {
    label: 'Middle Level Education',
    value: 'Middle Level Education'
  },
  {
    label: 'Music Therapy',
    value: 'Music Therapy'
  },
  {
    label: 'Nursing',
    value: 'Nursing'
  },
  {
    label: 'Occupational Therapy',
    value: 'Occupational Therapy'
  },
  {
    label: 'Organizational Leadership',
    value: 'Organizational Leadership'
  },
  {
    label: 'Photography and Digital Art',
    value: 'Photography and Digital Art'
  },
  {
    label: 'Physical Therapy',
    value: 'Physical Therapy'
  },
  {
    label: 'Pre-Chiropractic Medicine',
    value: 'Pre-Chiropractic Medicine'
  },
  {
    label: 'Pre-Dentistry',
    value: 'Pre-Dentistry'
  },
  {
    label: 'Pre-Law',
    value: 'Pre-Law'
  },
  {
    label: 'Pre-Medicine',
    value: 'Pre-Medicine'
  },
  {
    label: 'Pre-Occupational Therapy',
    value: 'Pre-Occupational Therapy'
  },
  {
    label: 'Pre-Optometry',
    value: 'Pre-Optometry'
  },
  {
    label: 'Pre-Osteopathic Medicine',
    value: 'Pre-Osteopathic Medicine'
  },
  {
    label: 'Pre-Pharmacy',
    value: 'Pre-Pharmacy'
  },
  {
    label: 'Pre-Physical Therapy',
    value: 'Pre-Physical Therapy'
  },
  {
    label: 'Pre-Physician Assistant',
    value: 'Pre-Physician Assistant'
  },
  {
    label: 'Pre-Podiatric Medicine',
    value: 'Pre-Podiatric Medicine'
  },
  {
    label: 'Pre-Veterinary',
    value: 'Pre-Veterinary'
  },
  {
    label: 'Psychology',
    value: 'Psychology'
  },
  {
    label: 'Psychology/Sociology',
    value: 'Psychology/Sociology'
  },
  {
    label: 'Science',
    value: 'Science'
  },
  {
    label: 'Secondary Education',
    value: 'Secondary Education'
  },
  {
    label: 'Sociology',
    value: 'Sociology'
  },
  {
    label: 'Speech Pathology (Early Admit)',
    value: 'Speech Pathology (Early Admit)'
  },
  {
    label: 'Sport Business Management',
    value: 'Sport Business Management'
  },
  {
    label: 'Sustainability and Environmental Stewardship',
    value: 'Sustainability and Environmental Stewardship'
  },
  {
    label: 'Undecided',
    value: 'Undecided'
  },
]

const anticipatedProgramTransferOptions = [
  {
    label: "...",
    value: "",
  },
  {
    label: 'Accounting',
    value: 'Accounting'
  },
  {
    label: 'Accounting Information Systems',
    value: 'Accounting Information Systems'
  },
  {
    label: 'Actuarial Science',
    value: 'Actuarial Science'
  },
  {
    label: 'Art (Studio)',
    value: 'Art (Studio)'
  },
  {
    label: 'Biochemistry',
    value: 'Biochemistry'
  },
  {
    label: 'Biology',
    value: 'Biology'
  },
  {
    label: 'Biomedical Science',
    value: 'Biomedical Science'
  },
  {
    label: 'Biotechnology',
    value: 'Biotechnology'
  },
  {
    label: 'Business Administration',
    value: 'Business Administration'
  },
  {
    label: 'Chemistry',
    value: 'Chemistry'
  },
  {
    label: 'Clinical Laboratory Science',
    value: 'Clinical Laboratory Science'
  },
  {
    label: 'Communication',
    value: 'Communication'
  },
  {
    label: 'Communication Sciences and Disorders',
    value: 'Communication Sciences and Disorders'
  },
  {
    label: 'Criminal Justice/Criminology',
    value: 'Criminal Justice/Criminology'
  },
  {
    label: 'Cyber Security',
    value: 'Cyber Security'
  },
  {
    label: 'Data Science',
    value: 'Data Science'
  },
  {
    label: 'Early Childhood and Elementary Education',
    value: 'Early Childhood and Elementary Education'
  },
  {
    label: 'Elementary Education',
    value: 'Elementary Education'
  },
  {
    label: 'Engineering (Dual Degree)',
    value: 'Engineering (Dual Degree)'
  },
  {
    label: 'English',
    value: 'English'
  },
  {
    label: 'Exercise Science',
    value: 'Exercise Science'
  },
  {
    label: 'Financial Services',
    value: 'Financial Services'
  },
  {
    label: 'Forensic Psychology/Criminal Justice',
    value: 'Forensic Psychology/Criminal Justice'
  },
  {
    label: 'Forensic Science',
    value: 'Forensic Science'
  },
  {
    label: 'Game Design',
    value: 'Game Design'
  },
  {
    label: 'Graphic Design',
    value: 'Graphic Design'
  },
  {
    label: 'History',
    value: 'History'
  },
  {
    label: 'Interactive Design',
    value: 'Interactive Design'
  },
  {
    label: 'Interior Design',
    value: 'Interior Design'
  },
  {
    label: 'International Studies',
    value: 'International Studies'
  },
  {
    label: 'Liberal Studies',
    value: 'Liberal Studies'
  },
  {
    label: 'Management and Leadership',
    value: 'Management and Leadership'
  },
  {
    label: 'Management Information Systems',
    value: 'Management Information Systems'
  },
  {
    label: 'Marketing',
    value: 'Marketing'
  },
  {
    label: 'Mathematics',
    value: 'Mathematics'
  },
  {
    label: 'Middle Level Education',
    value: 'Middle Level Education'
  },
  {
    label: 'Music Therapy',
    value: 'Music Therapy'
  },
  {
    label: 'Nursing (Fast-Track)',
    value: 'Nursing (Fast-Track)'
  },
  {
    label: 'Organizational Leadership',
    value: 'Organizational Leadership'
  },
  {
    label: 'Photography and Digital Art',
    value: 'Photography and Digital Art'
  },
  {
    label: 'Pre-Chiropractic Medicine',
    value: 'Pre-Chiropractic Medicine'
  },
  {
    label: 'Pre-Dentistry',
    value: 'Pre-Dentistry'
  },
  {
    label: 'Pre-Law',
    value: 'Pre-Law'
  },
  {
    label: 'Pre-Medicine',
    value: 'Pre-Medicine'
  },
  {
    label: 'Pre-Occupational Therapy',
    value: 'Pre-Occupational Therapy'
  },
  {
    label: 'Pre-Optometry',
    value: 'Pre-Optometry'
  },
  {
    label: 'Pre-Osteopathic Medicine',
    value: 'Pre-Osteopathic Medicine'
  },
  {
    label: 'Pre-Pharmacy',
    value: 'Pre-Pharmacy'
  },
  {
    label: 'Pre-Physical Therapy',
    value: 'Pre-Physical Therapy'
  },
  {
    label: 'Pre-Physician Assistant',
    value: 'Pre-Physician Assistant'
  },
  {
    label: 'Pre-Podiatric Medicine',
    value: 'Pre-Podiatric Medicine'
  },
  {
    label: 'Pre-Veterinary',
    value: 'Pre-Veterinary'
  },
  {
    label: 'Psychology',
    value: 'Psychology'
  },
  {
    label: 'Psychology/Sociology',
    value: 'Psychology/Sociology'
  },
  {
    label: 'Science',
    value: 'Science'
  },
  {
    label: 'Secondary Education',
    value: 'Secondary Education'
  },
  {
    label: 'Sociology',
    value: 'Sociology'
  },
  {
    label: 'Sport Business Management',
    value: 'Sport Business Management'
  },
  {
    label: 'Sustainability and Environmental Stewardship',
    value: 'Sustainability and Environmental Stewardship'
  },
  {
    label: 'Undecided',
    value: 'Undecided'
  },
];
